<template>
  <div class="row">
    <div
      v-for="element in tableData"
      v-bind:key="element.resourceDetails.resourceId"
      class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-6 mb-2 px-1"
    >
      <router-link :to="getLinkUrl(element.resourceDetails.resourceId)" >
        <div  class="container-item d-flex flex-column align-items-center justify-content-center iconContainer">
          
          <img  v-bind:src="element.imageUrl.url" />
            <p
              @click="eventCapacture"
              class="text-center appName"
              :title="element.name"
              v-html="getName(element.name)"
            ></p>
            <p class="text-center vendorName">{{element.vendorName}}</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { HighlightMixin } from "../js/mixin";

export default {
  name: "card-table",
  mixins: [HighlightMixin],
  data() {
    return {
      searchText: ""
    };
  },
  props: {
    context: {},
    tableData: { type: Array, default: null },
    tableId: { type: String, default: "" }
  },
  methods: {
   eventCapacture(){
     console.log("tiles click and capactured the data");
   },

    getName(name) {
      if (this.context != null) {
        return this._getHighlightedText(name, this.context.query);
      }
      return name;
    },
    getLinkUrl(uuid) {
      const idPath = uuid;
      
      return "/apps/detail/"+`${idPath}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/hpMixin.scss";
@import "../styles/hpCustom.scss";
@import "../styles/hpModule.scss";
@import "../styles/hpConstant.scss";

.container-item {
  outline: 1px solid $hpMediumGray;
  margin: 3%;
  padding: 8% 2%;
  width: 100%;
  height: 100%;
}

.row {
  margin: 0;
  padding: 0;
}

.iconContainer {
  background-color: $hpWhite;
  outline: 1px solid $hpMediumGray;
  min-height: 190px;

    .appName {
      font-size: 16px;
      padding-top: 8px;
      overflow-wrap: break-word;
      word-wrap: break-word;
      color: $hpBlack;
    }

  .vendorName {
          font-size: 18px;
          display: inline-table;
        }
}

p {
    display: inline-table;
    margin: 0;
}

.iconContainer:hover {
  outline: 1px solid $hpLightBlue;
  cursor: pointer;
}

.iconContainer:active {
  background-color: $hpBrighterBlue;
  outline: 1px solid $hpLightBlue;
  filter: alpha(opacity=80);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
  opacity: 0.75;
  -moz-opacity: 0.75;
  -khtml-opacity: 0.75;
}

</style>
